// 吃瓜影院 - 站内展示数据（虚构示例，仅用于页面呈现）
export const siteMeta = {
  name: '吃瓜影院',
  slogan: '吃瓜票房、排片、上映，一站看清场次热度',
  desc: '实时票房排行、今日排片分布、新片上映名单与最新档期窗口，帮你快速锁定想看的场次。',
};

export interface BoxOfficeMovie {
  rank: number;
  title: string;
  todayBox: number; // 今日票房 万元
  totalBox: string; // 累计票房
  showRate: number; // 排片占比 %
  seatRate: number; // 上座率 %
  heat: '爆棚' | '火热' | '上升' | '平稳';
  trend: number; // 较昨日 涨跌幅 %
  genre: string;
  release: string;
  img: string;
}

export const boxOfficeList: BoxOfficeMovie[] = [
  {
    rank: 1, title: '星海远征·黎明', todayBox: 2843, totalBox: '6.82亿', showRate: 26.4, seatRate: 41.2,
    heat: '爆棚', trend: 18.6, genre: '科幻·冒险', release: '上周五', img: 'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20space%20odyssey%20movie%20poster%20style%20art%2C%20astronaut%20silhouette%20facing%20glowing%20nebula%2C%20deep%20crimson%20and%20amber%20gold%20color%20palette%2C%20dramatic%20cinematic%20lighting%2C%20epic%20scale%2C%20dark%20background%2C%20detailed%20digital%20painting&width=480&height=640&seq=movie-starsail-01&orientation=portrait',
  },
  {
    rank: 2, title: '深夜放映厅', todayBox: 2110, totalBox: '3.47亿', showRate: 18.7, seatRate: 39.6,
    heat: '火热', trend: 9.4, genre: '悬疑·惊悚', release: '上周五', img: 'https://readdy.ai/api/search-image?query=noir%20mystery%20thriller%20movie%20poster%20art%2C%20dark%20cinema%20theater%20corridor%20with%20flickering%20red%20light%2C%20eerie%20atmosphere%2C%20deep%20shadow%2C%20amber%20lamp%20glow%2C%20cinematic%20composition%2C%20moody%20tone&width=480&height=640&seq=movie-midnight-02&orientation=portrait',
  },
  {
    rank: 3, title: '山那边的信', todayBox: 1786, totalBox: '5.19亿', showRate: 14.2, seatRate: 46.8,
    heat: '上升', trend: 21.2, genre: '剧情·家庭', release: '两周前', img: 'https://readdy.ai/api/search-image?query=heartwarming%20family%20drama%20film%20poster%20art%2C%20rustic%20mountain%20village%20scene%20golden%20hour%2C%20warm%20amber%20lighting%2C%20emotional%20cinematic%20storytelling%2C%20muted%20warm%20tones%2C%20soft%20focus&width=480&height=640&seq=movie-letter-03&orientation=portrait',
  },
  {
    rank: 4, title: '代号：蓝焰', todayBox: 1325, totalBox: '8.63亿', showRate: 12.5, seatRate: 33.1,
    heat: '平稳', trend: -2.8, genre: '动作·犯罪', release: '本月', img: 'https://readdy.ai/api/search-image?query=action%20crime%20blockbuster%20film%20poster%20art%2C%20lone%20spy%20silhouette%20against%20explosive%20blue%20flame%20but%20tinted%20warm%20red%2C%20high%20contrast%2C%20dynamic%20action%20pose%2C%20cinematic%20drama&width=480&height=640&seq=movie-flame-04&orientation=portrait',
  },
  {
    rank: 5, title: '风铃草小镇', todayBox: 986, totalBox: '2.05亿', showRate: 8.1, seatRate: 38.4,
    heat: '火热', trend: 12.7, genre: '动画·治愈', release: '上周五', img: 'https://readdy.ai/api/search-image?query=animated%20healing%20film%20poster%20art%2C%20cozy%20small%20town%20with%20bellflower%20flowers%2C%20soft%20warm%20pastel%20palette%2C%20gentle%20sunlight%2C%20cute%20stylized%20illustration%2C%20wholesome%20atmosphere&width=480&height=640&seq=movie-town-05&orientation=portrait',
  },
  {
    rank: 6, title: '潮汐上的灯塔', todayBox: 612, totalBox: '1.28亿', showRate: 5.3, seatRate: 30.9,
    heat: '平稳', trend: -1.4, genre: '爱情·剧情', release: '两周前', img: 'https://readdy.ai/api/search-image?query=romantic%20drama%20film%20poster%20art%2C%20lighthouse%20on%20stormy%20tidal%20coastline%20at%20sunset%2C%20warm%20gold%20and%20crimson%20sky%2C%20cinematic%20romantic%20atmosphere%2C%20reflective%20mood&width=480&height=640&seq=movie-lighthouse-06&orientation=portrait',
  },
  {
    rank: 7, title: '第十三层记忆', todayBox: 547, totalBox: '0.96亿', showRate: 4.9, seatRate: 27.5,
    heat: '上升', trend: 6.3, genre: '科幻·悬疑', release: '今日上映', img: 'https://readdy.ai/api/search-image?query=mind-bending%20sci-fi%20mystery%20movie%20poster%20art%2C%20layered%20memory%20spheres%20and%20geometric%20shapes%2C%20dark%20crimson%20neon%20glow%2C%20dreamlike%20surreal%20composition%2C%20conceptual%20art&width=480&height=640&seq=movie-memory-07&orientation=portrait',
  },
  {
    rank: 8, title: '归途列车', todayBox: 421, totalBox: '0.73亿', showRate: 3.6, seatRate: 31.2,
    heat: '平稳', trend: 3.9, genre: '公路·剧情', release: '今日上映', img: 'https://readdy.ai/api/search-image?query=road%20trip%20drama%20film%20poster%20art%2C%20lonely%20train%20journeying%20through%20winter%20landscape%20at%20dusk%2C%20nostalgic%20warm%20amber%20lighting%2C%20contemplative%20cinematic%20mood%2C%20travel%20story&width=480&height=640&seq=movie-train-08&orientation=portrait',
  },
  {
    rank: 9, title: '机械心跳', todayBox: 355, totalBox: '1.66亿', showRate: 3.1, seatRate: 25.8,
    heat: '平稳', trend: -4.2, genre: '动画·科幻', release: '本月', img: 'https://readdy.ai/api/search-image?query=animated%20robot%20sci-fi%20film%20poster%20art%2C%20sentient%20android%20with%20glowing%20amber%20core%20in%20heart%2C%20warm%20red%20mechanical%20details%2C%20futuristic%20yet%20emotional%20illustration&width=480&height=640&seq=movie-heart-09&orientation=portrait',
  },
  {
    rank: 10, title: '城市边缘', todayBox: 298, totalBox: '0.42亿', showRate: 2.9, seatRate: 33.6,
    heat: '上升', trend: 15.5, genre: '文艺·纪录', release: '今日上映', img: 'https://readdy.ai/api/search-image?query=artistic%20documentary%20film%20poster%20art%2C%20fragmented%20city%20skyline%20at%20night%20with%20warm%20street%20lights%2C%20observational%20cinema%20aesthetic%2C%20minimal%20moody%20tone%2C%20grainy%20texture&width=480&height=640&seq=movie-city-10&orientation=portrait',
  },
];

export interface Showtime {
  time: string;
  hall: string;
  lang: string;
  type: string;
  price: number;
  seats: number; // 余座
  total: number;
}

export interface ScreenMovie {
  title: string;
  img: string;
  genre: string;
  length: string;
  rate: string;
  times: Showtime[];
}

export const screenSchedule: ScreenMovie[] = [
  {
    title: '星海远征·黎明', genre: '科幻·冒险', length: '126分钟', rate: '9.1',
    img: 'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20space%20odyssey%20movie%20poster%20style%20art%2C%20astronaut%20silhouette%20facing%20glowing%20nebula%2C%20deep%20crimson%20and%20amber%20gold%20color%20palette%2C%20epic%20cinematic%20lighting&width=360&height=480&seq=movie-starsail-01&orientation=portrait',
    times: [
      { time: '10:20', hall: '3号厅', lang: '国语2D', type: 'IMAX', price: 49, seats: 12, total: 180 },
      { time: '13:40', hall: 'IMAX厅', lang: '国语3D', type: '杜比', price: 68, seats: 0, total: 360 },
      { time: '16:10', hall: '3号厅', lang: '国语2D', type: '巨幕', price: 55, seats: 45, total: 180 },
      { time: '19:30', hall: 'IMAX厅', lang: '国语3D', type: 'IMAX', price: 75, seats: 88, total: 360 },
      { time: '21:50', hall: '5号厅', lang: '国语2D', type: '巨幕', price: 55, seats: 32, total: 200 },
    ],
  },
  {
    title: '深夜放映厅', genre: '悬疑·惊悚', length: '112分钟', rate: '8.7',
    img: 'https://readdy.ai/api/search-image?query=noir%20mystery%20thriller%20movie%20poster%20art%2C%20dark%20cinema%20corridor%20with%20red%20light%2C%20eerie%20moody%20composition%2C%20deep%20shadow%20amber%20glow&width=360&height=480&seq=movie-midnight-02&orientation=portrait',
    times: [
      { time: '11:00', hall: '1号厅', lang: '国语2D', type: '标准', price: 38, seats: 25, total: 120 },
      { time: '14:20', hall: '1号厅', lang: '国语2D', type: '标准', price: 42, seats: 9, total: 120 },
      { time: '18:40', hall: '4号厅', lang: '国语2D', type: '4K', price: 48, seats: 66, total: 150 },
      { time: '22:10', hall: '4号厅', lang: '国语2D', type: '4K', price: 45, seats: 54, total: 150 },
    ],
  },
  {
    title: '山那边的信', genre: '剧情·家庭', length: '119分钟', rate: '9.3',
    img: 'https://readdy.ai/api/search-image?query=heartwarming%20family%20drama%20film%20poster%20art%2C%20mountain%20village%20golden%20hour%2C%20warm%20amber%20lighting%2C%20emotional%20cinematic%20storytelling&width=360&height=480&seq=movie-letter-03&orientation=portrait',
    times: [
      { time: '09:40', hall: '2号厅', lang: '国语2D', type: '标准', price: 35, seats: 40, total: 130 },
      { time: '13:10', hall: '2号厅', lang: '国语2D', type: '标准', price: 40, seats: 18, total: 130 },
      { time: '17:00', hall: '6号厅', lang: '国语2D', type: '亲子', price: 45, seats: 5, total: 160 },
      { time: '20:15', hall: '2号厅', lang: '国语2D', type: '标准', price: 46, seats: 73, total: 130 },
    ],
  },
  {
    title: '代号：蓝焰', genre: '动作·犯罪', length: '135分钟', rate: '8.2',
    img: 'https://readdy.ai/api/search-image?query=action%20crime%20blockbuster%20film%20poster%20art%2C%20lone%20spy%20against%20explosive%20flame%2C%20dynamic%20action%20pose%2C%20cinematic%20high%20contrast&width=360&height=480&seq=movie-flame-04&orientation=portrait',
    times: [
      { time: '12:30', hall: 'IMAX厅', lang: '国语3D', type: 'IMAX', price: 66, seats: 3, total: 360 },
      { time: '15:50', hall: '3号厅', lang: '国语2D', type: '巨幕', price: 52, seats: 27, total: 180 },
      { time: '20:00', hall: 'IMAX厅', lang: '国语3D', type: 'IMAX', price: 72, seats: 120, total: 360 },
    ],
  },
  {
    title: '风铃草小镇', genre: '动画·治愈', length: '98分钟', rate: '9.0',
    img: 'https://readdy.ai/api/search-image?query=animated%20healing%20film%20poster%20art%2C%20cozy%20small%20town%20with%20bellflowers%2C%20soft%20warm%20pastel%2C%20cute%20stylized%20illustration&width=360&height=480&seq=movie-town-05&orientation=portrait',
    times: [
      { time: '10:00', hall: '6号厅', lang: '国语2D', type: '亲子', price: 42, seats: 60, total: 160 },
      { time: '14:10', hall: '6号厅', lang: '国语2D', type: '亲子', price: 45, seats: 22, total: 160 },
      { time: '19:00', hall: '6号厅', lang: '国语2D', type: '亲子', price: 50, seats: 85, total: 160 },
    ],
  },
];

export interface ReleaseMovie {
  title: string;
  date: string;
  weekday: string;
  genre: string;
  format: string;
  expect: number; // 想看人数 万
  desc: string;
  img: string;
  badge?: string;
}

export const releaseList: ReleaseMovie[] = [
  {
    title: '第十三层记忆', date: '09.07', weekday: '今天', genre: '科幻·悬疑', format: '2D/IMAX',
    expect: 48, badge: '今日上映',
    desc: '记忆被切割成十三层档案，调查员在最后一层遇见了十年前失踪的自己。口碑提前解禁，悬疑爱好者必追。',
    img: 'https://readdy.ai/api/search-image?query=mind-bending%20sci-fi%20mystery%20movie%20poster%2C%20layered%20memory%20spheres%2C%20dark%20crimson%20neon%20glow%2C%20surreal%20dreamlike%20art&width=400&height=540&seq=rel-memory-07&orientation=portrait',
  },
  {
    title: '归途列车', date: '09.07', weekday: '今天', genre: '公路·剧情', format: '2D',
    expect: 21, badge: '今日上映',
    desc: '一辆开往家乡的慢车，载着三段各怀心事的人生。治愈系公路片，适合安静坐下来慢慢看。',
    img: 'https://readdy.ai/api/search-image?query=road%20trip%20drama%20film%20poster%2C%20train%20through%20winter%20landscape%20at%20dusk%2C%20nostalgic%20warm%20amber%20lighting%2C%20cinematic&width=400&height=540&seq=rel-train-08&orientation=portrait',
  },
  {
    title: '城市边缘', date: '09.07', weekday: '今天', genre: '文艺·纪录', format: '2D',
    expect: 8, badge: '今日上映',
    desc: '凌晨四点的城市群像，导演用两年跟拍记录深夜守护者的一天。现实题材，评价两极化但极具力量。',
    img: 'https://readdy.ai/api/search-image?query=artistic%20documentary%20film%20poster%2C%20fragmented%20city%20skyline%20at%20night%20warm%20lights%2C%20observational%20cinema%20moody%20grainy&width=400&height=540&seq=rel-city-10&orientation=portrait',
  },
  {
    title: '无风之海', date: '09.13', weekday: '周六', genre: '爱情·奇幻', format: '2D/杜比',
    expect: 73, badge: '即将上映',
    desc: '当潮汐静止，整座海岛停在一场未完的告白里。奇幻爱情大片，预定本周末话题担当。',
    img: 'https://readdy.ai/api/search-image?query=romantic%20fantasy%20film%20poster%2C%20still%20calm%20sea%20mirror%20sky%2C%20warm%20gold%20dusk%20palette%2C%20ethereal%20cinematic%20romance&width=400&height=540&seq=rel-sea-11&orientation=portrait',
  },
  {
    title: '熊猫列车号', date: '09.13', weekday: '周六', genre: '动画·冒险', format: '3D/IMAX',
    expect: 92, badge: '即将上映',
    desc: '全年龄合家欢冒险动画，一只爱穿蓝色背带裤的熊猫带着孩子们坐上会飞的列车环游世界。',
    img: 'https://readdy.ai/api/search-image?query=animated%20family%20adventure%20film%20poster%2C%20cute%20panda%20on%20flying%20train%20colorful%20sky%2C%20vibrant%20warm%20stylized%20illustration&width=400&height=540&seq=rel-panda-12&orientation=portrait',
  },
  {
    title: '戈壁夜行', date: '09.20', weekday: '周六', genre: '动作·冒险', format: '2D/IMAX',
    expect: 65, badge: '敬请期待',
    desc: '跨国犯罪动作片，纵贯沙漠的追车长镜头与硬核格斗，男主为救被绑架的考古队深入无人区。',
    img: 'https://readdy.ai/api/search-image?query=action%20adventure%20film%20poster%2C%20gobi%20desert%20night%20with%20headlights%20and%20dust%2C%20warm%20sand%20red%20tone%2C%20tense%20cinematic%20thriller&width=400&height=540&seq=rel-gobi-13&orientation=portrait',
  },
];

export interface ScheduleWindow {
  period: string;
  date: string;
  name: string;
  hot: number;
  note: string;
  tag: '重点' | '国产' | '引进' | '合家欢';
}

export const scheduleWindows: ScheduleWindow[] = [
  { period: '国庆档', date: '09.30-10.07', name: '祖国，生日快乐', hot: 9.6, tag: '重点', note: '主旋律献礼，全明星阵容，国庆档最稳种子。' },
  { period: '国庆档', date: '10.01', name: '龙抬头', hot: 9.2, tag: '国产', note: '国风武侠巨制，东方美学视觉盛宴。' },
  { period: '国庆档', date: '10.01', name: '疯狂动物城2', hot: 9.0, tag: '引进', note: '全球现象级动画续作，合家欢首选。' },
  { period: '中秋·国庆', date: '09.15-10.10', name: '月是故乡明', hot: 8.8, tag: '国产', note: '中秋应景温情片，三线叙事群像。' },
  { period: '贺岁档', date: '12.24', name: '雪国列车重启', hot: 8.5, tag: '引进', note: '顶级视效灾难片，岁末压轴动作大戏。' },
  { period: '贺岁档', date: '2027.01.01', name: '新年首映会', hot: 8.2, tag: '合家欢', note: '跨年合家欢喜剧，全年龄爆笑套餐。' },
];

export interface NewsItem {
  id: number;
  title: string;
  excerpt: string;
  tag: string;
  date: string;
  read: number;
}

export const newsList: NewsItem[] = [
  {
    id: 1, tag: '票房观察', date: '09.07', read: 12000,
    title: '《星海远征·黎明》连续霸榜，暑期档后最强科幻为何是它？',
    excerpt: '单日票房逼近三千万，排片占比稳居第一。除了顶配视效，这片靠的其实是"高概念+强共情"的双引擎打法。',
  },
  {
    id: 2, tag: '排片解读', date: '09.06', read: 8600,
    title: '国庆档排片前瞻：谁在抢IMAX厅，谁在错峰捡漏？',
    excerpt: '三大片同日上映已成定局，影城经理怎么看排片策略？我们用一线院线数据拆解档期背后的排片逻辑。',
  },
  {
    id: 3, tag: '上映资讯', date: '09.05', read: 6300,
    title: '本周新片上映名单：两部黑马能否撬动大盘？',
    excerpt: '周五扎堆上映的名单已出，《第十三层记忆》靠口碑长尾，《城市边缘》则主打文艺院线精准收割。',
  },
  {
    id: 4, tag: '档期窗口', date: '09.04', read: 9800,
    title: '中秋国庆档窗口前瞻：观影热度何时见顶？',
    excerpt: '从历年数据看，档期窗口的票房曲线并不总随影片质量走，档位、定档节奏与社交传播才是隐形变量。',
  },
  {
    id: 5, tag: '数据盘点', date: '09.03', read: 4100,
    title: '上座率与排片的微妙博弈：好口碑为何卖不过大排片',
    excerpt: '一部片口碑封神却场次寥寥，另一部槽点满满却场场爆满。上座率、排片与场次之间到底谁说了算？',
  },
  {
    id: 6, tag: '购票指南', date: '09.02', read: 5200,
    title: '手把手教你挑场次：IMAX、巨幕与杜比怎么选不踩雷',
    excerpt: '同一部电影在不同厅的体验天差地别。一张图看懂IMAX、杜比全景声与普通巨幕的真实差别与价格陷阱。',
  },
];

export interface Faq {
  q: string;
  a: string;
}

export const faqList: Faq[] = [
  {
    q: '吃瓜影院的实时票房数据从哪里来？',
    a: '吃瓜影院票房数据每日分时更新，汇总自全国主流院线与票务平台的公开场次与票房口径，页面展示的金额、排片占比与上座率均为当日统计快照，供影迷参考，不代表官方结算口径。',
  },
  {
    q: '如何查看某部影片的今日排片与场次？',
    a: '进入首页"今日排片"板块，可按影片名称切换，每个影厅的时间、版本（2D/3D）、放映厅与余座都会清晰列出。点击对应场次即可查看该影片当前热度与实时票房排行。',
  },
  {
    q: '新片上映名单和档期窗口多久更新一次？',
    a: '新片上映名单与档期窗口随定档信息实时更新。凡官方宣布定档的影片，我们会在名单中第一时间标注上映日期、类型与"想看"人数，并同步热点档期（如国庆、贺岁）的片单。',
  },
  {
    q: '票房排行里的"较昨日涨幅"是什么意思？',
    a: '涨幅 =（今日当前票房 − 昨日同期票房）÷ 昨日同期票房 × 100%。由于是按同一时刻同比，能够更准确地反映影片单日票房是冲高还是回落，从而判断影片的市场热度趋势。',
  },
  {
    q: '我能在吃瓜影院直接购票吗？',
    a: '目前吃瓜影院定位为电影情报与票房排片资讯平台，聚焦数据呈现与场次筛选。我们暂不提供在线购票与选座服务，建议您在确认场次后前往各大票务平台完成购票。',
  },
  {
    q: '可以投稿或爆料票房、排片相关资讯吗？',
    a: '欢迎影迷与从业者投稿。凡涉及票房数据、排片动态或档期变动的线索，可将信息发送至官方投稿邮箱，一经核实采纳，我们会注明来源并在相关板块展示。',
  },
];